import _ from 'lodash';

function parseHint(value, showParenthesis) {
  if (_.isEmpty(value)) return '';

  return showParenthesis ? `(${value})` : value;
}

export { parseHint };
